import React from 'react';
import { FixedSizeList as List } from "react-window";
import IPricingOption from "../../../../../interfaces/IPricingOption";
import { OrderListItem } from "../../../../orders/OrderList/OrderListItem";
import { OrderListHeaders } from "../../../../orders/OrderList/OrderListViewHeaders";
import { priceOptionColumns } from "./columns";
import { Skeleton } from "@material-ui/lab";
import { useStyles } from "../styles";

interface IPriceOptionsList {
  priceOptions: {
    [key: string]: IPricingOption;
  },
  isLoading: boolean
}
export function PriceOptionsList({ priceOptions, isLoading }: IPriceOptionsList) {
  const classes = useStyles();

  function Row({ index, style }: any) {
    const item = Object.values(priceOptions)[index];
    return (
      <div style={style} key={index} data-component-name="PriceOptionItem">
        <OrderListItem order={item as any} columns={priceOptionColumns}
          props={item}
          className={classes.priceOptionItem}
        />
      </div>
    );
  }
  function checkPriceOptions() {
    if (isLoading || !priceOptions) {
      return (
        <div>
          <Skeleton />
          <Skeleton />
        </div>
      )
    }
    else if (priceOptions && Object.values(priceOptions).length < 1) {
      const item = {
        "option_name": "-",
        "option_price": "-",
        "option_price_exclusive": "-",
        "option_discount": "-"
      }
      return (<div data-component-name="PriceOptionItem">
        <OrderListItem order={item as any} columns={priceOptionColumns}
          props={item}
          className={classes.priceOptionItem}
        />
      </div>)
    }
    else return (
      <List height={50}
        itemCount={Object.values(priceOptions).length}
        itemSize={20}
        width={"100%"}
        style={{
          overflow: "auto",
        }}
      >
        {Row}
      </List>
    )
  }
  return (
    <div className={classes.priceOptionsContainer}>
      <div key={`columnHeaders-priceOptionHeader`} className={classes.columnsHeader}>
        {priceOptionColumns.map((column) => <OrderListHeaders {...column} key={`col-${column.key}-${column.label}`} />)}
      </div>
      <div style={{
        width: "100%",
        height: "100%",
        paddingTop: "5px"
      }}>
        {checkPriceOptions()}
      </div>
    </div>
  )
}
